import React from 'react'
import NumberContainer from './numberContainer'
import { useHideInput } from '../../contextHook/hideInput'

const FloatingDisplay = ({ fullScreenActive }) => {
  const { hiding } = useHideInput()
  return (
    <>
      {(fullScreenActive || hiding) && (
        <NumberContainer onFloating={fullScreenActive || hiding} />
      )}
    </>
  )
}

export default FloatingDisplay
